export { default, useThemeMode, THEME_STORAGE_KEY } from '@/shared/components/ThemeRoot';
export type { ThemeMode, ThemePreference } from '@/shared/components/ThemeRoot';

export { ThemeScope } from '@/shared/components/ThemeRoot';
